import { jsx } from "react/jsx-runtime";
import React, { Children, cloneElement, forwardRef } from "react";
import cx from "classnames";
const ListView = forwardRef((props, ref) => {
  const {
    children,
    prefix = "",
    id,
    className,
    size = "medium",
    showDivider = true,
    ...otherProps
  } = props;
  const classes = cx(
    `${prefix}list-view`,
    `${prefix}list-view--${size}`,
    className
  );
  return /* @__PURE__ */ jsx(
    "ul",
    {
      id,
      ref,
      role: "list",
      className: classes,
      ...otherProps,
      children: Children.map(children, (child, i) => {
        if (React.isValidElement(child)) {
          return cloneElement(child, {
            id: child.props.id ? child.props.id : `${prefix}${id}-${i}`,
            name: child.props.name ? child.props.name : `${prefix}${id}`,
            showDivider,
            size
          });
        }
        return child;
      })
    }
  );
});
ListView.displayName = "ListView";
var ListView_default = ListView;
export {
  ListView_default as default
};
